import React from 'react';
import { Link } from 'react-router-dom';

export class DiscoverListElement extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<li className="col-xlarge-4 col-medium-4 animated fadeIn">
				<Link to={'/entdecken/' + this.props.discoverElement.slug} className="discover-item">
					<div style={{backgroundImage: `url(${this.props.discoverElement.acf.backgroundImage})`}} className="discover__item-background-image" />
					<div className="discover__item-title">
						<div className="discover__item-title-content">
							<h3>{this.props.discoverElement.title.rendered}</h3>
						</div>
					</div>
				</Link>
			</li>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Discover/DiscoverListElement.js